import { z } from "zod";
import { MAX_MENTIONS_PER_CONTENT } from "../../utils/mentions.js";

export const createCommentSchema = z.object({
	content: z.string().min(1).max(2000),
	parent_id: z.string().optional(),
	mention_ids: z.array(z.uuid()).max(MAX_MENTIONS_PER_CONTENT).optional(),
});

export type CreateCommentPayload = z.infer<typeof createCommentSchema>;
